import { useState } from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faRightFromBracket, faXmark, faUserGear } from "@fortawesome/free-solid-svg-icons";

export default function GuestSettingsModal({ isOpen, onClose }) {
  const predefinedColors = [
    "#FF0000", "#0000FF", "#008000",
    "#F0C1D4", "#5D9AA3", "#2CA78B", "#59BDCC", "#8C9ED6"
  ];

  const [nickname, setNickname] = useState(localStorage.getItem("guestName") || "");
  const [color, setColor] = useState(localStorage.getItem("guestColor") || "#000000");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  const guestId = localStorage.getItem("guestID");
  const secretId = localStorage.getItem("secretId"); // do zapisu (jak wcześniej)

  const safeParseJson = (text) => {
    try { return JSON.parse(text); } catch { return null; }
  };

  /* ---------------- ZAPIS ---------------- */
  const handleSave = async () => {
    if (!guestId || !secretId || !nickname.trim()) {
      setMessage("Brak wymaganych danych.");
      return;
    }
    setSaving(true);
    setMessage("");

    try {
      // 1) JSON
      const res = await fetch("https://api18081113.sayq.pl/update-guest-settings", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          secretId,
          guestId,
          name: nickname.trim(),
          nameTheme: color
        })
      });

      const text = await res.text();
      const data = safeParseJson(text);

      let success = res.ok && data && data.success !== false && !data?.error;

      // 2) Fallback FormData
      if (!success) {
        const fd = new FormData();
        fd.append("secretId", secretId);
        fd.append("secred-id", secretId); // legacy kompatybilność
        fd.append("guestId", guestId);
        fd.append("guest_id", guestId);
        fd.append("name", nickname.trim());
        fd.append("nameTheme", color);

        const res2 = await fetch("https://api18081113.sayq.pl/update-guest-settings", {
          method: "POST",
          body: fd,
        });

        const text2 = await res2.text();
        const data2 = safeParseJson(text2);
        success = res2.ok && data2 && data2.success !== false && !data2?.error;
      }

      if (success) {
        localStorage.setItem("guestName", nickname.trim());
        localStorage.setItem("guestColor", color);
        setMessage("✅ Zapisano ustawienia");
        setTimeout(() => setMessage(""), 2000); // Clear message
      } else {
        setMessage("❌ Błąd zapisu ustawień");
      }
    } catch (err) {
      console.error("Błąd zapisu ustawień gościa:", err);
      setMessage("❌ Błąd zapisu");
    } finally {
      setSaving(false);
    }
  };

  /* ---------------- WYLOGUJ Z WYDARZENIA ---------------- */
  const handleLogoutFromEvent = () => {
    try {
      const currentGuest = localStorage.getItem("guestID");
      if (currentGuest) {
        localStorage.setItem("oldGuestID", currentGuest);
        localStorage.removeItem("guestID");
      }

      const secredId =
        localStorage.getItem("secredId") ||
        localStorage.getItem("secretId") ||
        localStorage.getItem("secred-id") ||
        localStorage.getItem("secret-id");

      if (!secredId) {
        setMessage("❌ Brak secredId w localStorage – nie mogę przekierować.");
        return;
      }

      window.location.href = `https://sayq.pl/guestRegister/${secredId}`;
    } catch (e) {
      console.error("Wylogowanie z wydarzenia nie powiodło się:", e);
      setMessage("❌ Nie udało się wylogować.");
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="settings-fix-overlay">
        <div className="settings-fix-container">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
            <h2 className="m-0 fw-bold d-flex align-items-center gap-3">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                <FontAwesomeIcon icon={faUserGear} className="fs-5" />
              </div>
              Ustawienia
            </h2>
            <button
              onClick={onClose}
              className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center transition-transform hover-scale"
              style={{ width: 44, height: 44 }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <div className="settings-content custom-scrollbar">

            {/* Nickname Input */}
            <div className="mb-4">
              <label className="fw-bold mb-2 d-block text-secondary small text-uppercase ls-1">Twój Nick</label>
              <input
                type="text"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                className="form-control form-control-lg rounded-4 border-0 bg-light shadow-sm"
                placeholder="Wpisz swój nick..."
                maxLength={40}
                style={{ padding: '15px' }}
              />
            </div>

            {/* Colors */}
            <div className="mb-5">
              <label className="fw-bold mb-3 d-block text-secondary small text-uppercase ls-1">Kolor nicku</label>
              <div className="d-flex flex-wrap gap-3">
                {predefinedColors.map((col) => (
                  <button
                    key={col}
                    onClick={() => setColor(col)}
                    className={`color-circle ${color === col ? 'active' : ''}`}
                    style={{ backgroundColor: col }}
                    aria-label={`Wybierz kolor ${col}`}
                    type="button"
                  />
                ))}
              </div>
            </div>

            {/* Messages */}
            {message && (
              <div className={`alert mb-4 rounded-3 text-center fw-bold ${message.includes('❌') ? 'alert-danger' : 'alert-success'}`}>
                {message}
              </div>
            )}

            {/* Actions */}
            <div className="d-flex justify-content-center align-items-center gap-4 mt-auto pt-4 border-top w-100">
              <button
                onClick={handleLogoutFromEvent}
                className="btn btn-link text-decoration-none text-danger fw-bold d-flex align-items-center gap-2 hover-opacity"
                style={{ fontSize: '0.9rem' }}
                title="Wyloguj się"
              >
                <FontAwesomeIcon icon={faRightFromBracket} /> Wyloguj
              </button>

              <button
                onClick={handleSave}
                disabled={saving}
                className="btn btn-primary rounded-pill px-5 py-2 fw-bold d-flex align-items-center gap-2 shadow-sm hover-lift"
                style={{ minWidth: '150px', justifyContent: 'center' }}
              >
                {saving ? 'Zapisywanie...' : <><FontAwesomeIcon icon={faFloppyDisk} /> Zapisz</>}
              </button>
            </div>

          </div>
        </div>
      </div>

      <style>{`
        .settings-fix-overlay {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background-color: rgba(0,0,0,0.6);
            backdrop-filter: blur(8px);
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
            animation: fadeIn 0.3s ease-out;
        }

        .settings-fix-container {
            background: #fff;
            width: 100%;
            max-width: 600px;
            /* Auto height but max screen */
            max-height: 90vh;
            border-radius: 24px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            padding: 30px;
            display: flex;
            flex-direction: column;
            animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            position: relative;
        }

        @media (max-width: 768px) {
            .settings-fix-container {
                height: auto;
                min-height: 60vh;
                width: 95%;
                border-radius: 20px;
                padding: 20px;
            }
        }

        .settings-content {
            flex: 1;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
        }
        
        .ls-1 { letter-spacing: 1px; }

        .form-control:focus {
            box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15) !important;
            background-color: #fff !important;
        }

        .color-circle {
            width: 45px; 
            height: 45px; 
            border-radius: 50%; 
            border: 3px solid transparent; 
            transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            cursor: pointer;
        }
        .color-circle:hover { 
            transform: scale(1.1) translateY(-2px); 
        }
        .color-circle.active { 
            border-color: #333; 
            transform: scale(1.15); 
            box-shadow: 0 5px 15px rgba(0,0,0,0.15); 
        }

        .hover-lift:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
        
        .hover-scale:hover {
            transform: scale(1.1);
        }

        /* Scrollbar */
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(40px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

        /* Dark Mode Support */
        body.dark-mode .settings-fix-container {
            background: #1e1e1e;
            color: #f3f4f6;
            border: 1px solid #333;
        }
        body.dark-mode .border-bottom, body.dark-mode .border-top {
            border-color: #333 !important;
        }
        body.dark-mode .btn-light {
             background: #2d2d2d;
             color: #fff;
             border-color: #444;
        }
        body.dark-mode .bg-light {
             background-color: #2d2d2d !important;
             color: #fff;
        }
        body.dark-mode .text-secondary {
             color: #adb5bd !important;
        }
        body.dark-mode .color-circle.active { 
            border-color: #fff; 
        }
      `}</style>
    </>
  );
}
